import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-20" }, null, -1)
const _hoisted_2 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4 mb-5 mb-sm-0" }
const _hoisted_3 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_4 = {
  key: 0,
  type: "button",
  class: "position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto",
  "data-bs-dismiss": "alert"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-primary" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["col-12 alert border border-primary d-flex flex-column flex-sm-row p-2 mb-2", [item.alert, item.color]])
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(index), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", {
            class: _normalizeClass(["mb-1", item.color])
          }, _toDisplayString(item.name), 3),
          _createElementVNode("span", null, _toDisplayString(item.companyName), 1)
        ]),
        (item.alert === 'alert-dismissible')
          ? (_openBlock(), _createElementBlock("button", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ], 64))
}